import React from 'react';
import Conditional from './../common/conditional';
import OrderBill from './../order-bill';
import SalesSummaryBill from './../sales-summary-bill';

const PrinterManagment = ({ someOrdersPendingToPrint }) => {
  return (
    <div>
      <Conditional if={someOrdersPendingToPrint}>
        <OrderBill />
      </Conditional>
      <Conditional if={!someOrdersPendingToPrint}>
        <SalesSummaryBill />
      </Conditional>
    </div>
  );
};

PrinterManagment.defaultProps = {
  classes: {},
};
export default PrinterManagment;
